// Checkout UI reports facts; the tracking component decides which analytics to send.
// Events bubble within the checkout and carry only a step name or an error stage.
export const CHECKOUT_STEP_EVENT = 'payments:checkout:step'
export const CHECKOUT_SUBMIT_EVENT = 'payments:checkout:submit'
export const CHECKOUT_ERROR_EVENT = 'payments:checkout:error'
